import { Component, Input, OnInit, ViewContainerRef } from '@angular/core';

import { Field } from '../../../core/field/abstract';

@Component({
    selector: 'cmn-check-radio',
    templateUrl: './check-radio.component.html',
    styleUrls: [ './check-radio.component.scss' ],
})

export class CheckRadioComponent extends Field implements OnInit {
    @Input() public readonly id: string;
    @Input() public readonly name: string;
    @Input() public readonly label: string;
    @Input() public readonly isRtl: boolean;
    @Input() public readonly isDisabled: boolean;
    @Input('class') public readonly clazz: string;
    @Input() public readonly type: 'radio' | 'checkbox' = 'checkbox';

    constructor(private readonly viewRef: ViewContainerRef) {
        super(viewRef);
    }

    public ngOnInit(): void {
        super.ngOnInit();

        this.addFormValidator(this.name, []);
    }

    public onChange(): void {
        this.form.get(this.name).setValue(!this.form.get(this.name).value);
    }
}
